export default {"src":"/_next/static/media/assistant-nurse-with-small-grey-text-box.021b09ee.svg","height":391,"width":260};